export class UserProfile {
  id: string; // identity sub
  email: string;
  emailAlias: string;
  firstName: string; // Currently only available in PROD (different Auth strategy)
  lastName: string; // Currently only available in PROD (different Auth strategy)
  phoneNumber: string;
  userName: string;
  signupDate: string; // ISO-8601 format
  preparedBy?: string; // Optional field for "Prepared by" text

  // User Limitations
  numTests: number; // default is 0
  numTestsAllowed: number; // "unlimited" - the value should be 99,999 in DB, default is 2
  pdfExportAllowed: boolean;
  pdfExportComparisonTableAllowed: boolean;
  editClientAllowed: boolean;
  editTestResultsAllowed: boolean;
  showClientComparisonTable: boolean;
  showAnalyzeResultsComparison: boolean;
  uploadTestResults: boolean;
  showUploadTestResults: boolean;
  customLogoUrl: string;
  customLogoAllowed: boolean;
  enabledSupplementBrands: string[] = ['systemicFormulas'];

  canAddTest(): boolean {
    if (this.numTests < this.numTestsAllowed) {
      return true;
    }
    return false;
  }

  canUploadPdf(): boolean {
    return this.uploadTestResults;
  }

  canSeeUploadTestResults(): boolean {
    return this.showUploadTestResults;
  }

  canUploadCustomLogo(): boolean {
    return this.customLogoAllowed;
  }

  hasCustomLogo(): boolean {
    return (
      this.canUploadCustomLogo() &&
      !!this.customLogoUrl &&
      this.customLogoUrl.trim() !== ''
    );
  }

  getLogoUrl(): string {
    return this.canUploadCustomLogo() && this.hasCustomLogo()
      ? this.customLogoUrl
      : '/assets/imgs/logo.png';
  }

  incrementNumTests(): void {
    this.numTests++;
  }

  constructor(userProfile?: UserProfile) {
    // This handles copying the simple properties
    if (!userProfile) {
      return;
    }
    // This handles copying the simple properties
    Object.keys(userProfile).forEach(key => {
      this[key] = userProfile[key];
    });
  }
}
